import {
  HttpClient
} from '@angular/common/http';
import {
  Inject,
  Injectable
} from '@angular/core';
import {
  Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { WINDOW } from '../../providers/window.provider';
import { CookiesService } from '../Cookie/cookies.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private router: Router,
              private http: HttpClient, private cookiesService: CookiesService,
              @Inject(WINDOW) private window: Window) { }


    isUserLoggedIn(): Observable<any> {
      let url = '';
      if (this.window.location.host.indexOf('www') > -1) {
        url = 'https://www.creatics.org/api/is-authenticated';
      } else {
        url = environment.apiURL + 'api/is-authenticated';
      }
      return this.http.get(url, {responseType: 'text'});
    }

    isUserLoggedInManual(): Observable<any> {
      let url = '';

      if (this.window.location.host.indexOf('www') > -1) {
        url = 'https://www.creatics.org/api/is-authenticated-manual';
      } else {
        url = environment.apiURL + 'api/is-authenticated-manual';
        console.log(url);
      }
      console.log(this.http.get(url, {responseType: 'text'}));
      return this.http.get(url, {responseType: 'text'});
    }

    logout(): void {
      console.log('logging user out from service');
      if (this.window.location.hostname !== 'localhost') {
        console.log('host: ' + this.window.location.host);
        this.window.location.href = environment.apiURL + 'login?referer=' + window.location.pathname.substring(1);
      } else {
        this.window.location.href = 'http://localhost:8080/login';
      }
    }

    checkUserAuthenticated(): Observable<any>{
      const url = environment.apiURL + 'api/login-details';
      return this.http.get(url);
    }

}
